import { render, staticRenderFns } from "./ApprovalEmas.vue?vue&type=template&id=1a925596&"
import script from "./ApprovalEmas.vue?vue&type=script&lang=js&"
export * from "./ApprovalEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports